import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../lib/LanguageContext';
import translations from '../lib/translations';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-col footer-brand">
          <img src="/logo.svg" alt="MegaTransact" className="footer-logo-img" />
          <p className="footer-desc">{t.desc}</p>
          <p className="footer-company">{t.company}</p>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">{t.legalDocs}</h3>
          <ul className="footer-links">
            <li>
              <Link to="/terms-and-conditions">{t.termsLink}</Link>
            </li>
            <li>
              <Link to="/privacy-policy">{t.privacyLink}</Link>
            </li>
            <li>
              <Link to="/lending-terms">{t.lendingLink}</Link>
            </li>
            <li>
              <Link to="/responsible-use">{t.responsibleLink}</Link>
            </li>
            <li>
              <Link to="/delete-account">{t.deleteLink}</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">{t.contact}</h3>
          <address className="footer-address">
            <p>{t.company}</p>
            <p>
              {t.address.split('\n').map((line, i, arr) => (
                <React.Fragment key={i}>
                  {line}
                  {i < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
            <p>
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
          </address>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t.copyright.replace('{year}', year)}</p>
        <p>{t.lastUpdated}</p>
      </div>
    </footer>
  );
}

export default Footer;
